import actions from './actions';

const {

  TEAMGROUPS_ADD_BEGIN,
  TEAMGROUPS_ADD_SUCCESS,
  TEAMGROUPS_ADD_ERR,

  TEAMGROUP_DELETE_BEGIN,
  TEAMGROUP_DELETE_SUCCESS,
  TEAMGROUP_DELETE_ERR,

  TEAMGROUP_UPDATE_BEGIN,
  TEAMGROUP_UPDATE_SUCCESS,
  TEAMGROUP_UPDATE_ERR,

  GET_TEAMGROUP_READ_SUCCESS,
  GET_TEAMGROUP_READ_ERR,
  GET_TEAMGROUP_READ_BEGIN,




} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const singlepersoninitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const addinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const updateStateSingle = {
  data: null,
  loading: false,
  error: null,
};
const updateinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const deleteinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};
const teamgroupUpdateReducer = (state = updateinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case TEAMGROUP_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case TEAMGROUP_UPDATE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case TEAMGROUP_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};


const TEAMGROUPDeleteReducer = (state = deleteinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case TEAMGROUP_DELETE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case TEAMGROUP_DELETE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case TEAMGROUP_DELETE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};


const TEAMGROUPAddReducer = (state = addinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case TEAMGROUPS_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case TEAMGROUPS_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case TEAMGROUPS_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };


    default:
      return state;
  }
};



const GetTeamGroupReducer = (state = singlepersoninitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_TEAMGROUP_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case GET_TEAMGROUP_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case GET_TEAMGROUP_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};



export {
  TEAMGROUPDeleteReducer, teamgroupUpdateReducer, GetTeamGroupReducer, TEAMGROUPAddReducer
};
